<script setup lang="ts" generic="Value">
import { useField } from 'vee-validate';
import type { VeeSelectFieldProps } from '../types';
import Select from './Select.vue';
import { toRef } from 'vue';
import { useVeeFormProps } from '../utils';

const emits = defineEmits<{
  change: [value: Value | Value[]];
}>();

const props = defineProps<VeeSelectFieldProps<Value>>();

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, setTouched } = useField<Value | Value[]>(
  toRef(() => props.name),
);

function onUpdate(input: Value | Value[]) {
  handleChange(input);
  setTouched(true);
  emits('change', input);
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <Select
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="errorMessage"
    @blur="onBlur"
    @update:modelValue="onUpdate"
  />
</template>
